<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Normal__And__Centre_Alignment"><span><span style=" font-style: italic; font-size: 1.17em;">To my family and friends </span></span></p>
<p class="P_Normal__And__Centre_Alignment"><span><span style=" font-style: italic; font-size: 1.17em;">on both sides of the Atlantic.</span></span></p>
<p class="P_Normal__And__Centre_Alignment"><span><span style=" font-style: italic; font-size: 1.17em;">- Natalia</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?50c9bb3e